import { useTranslation } from 'next-i18next';
import type { WorkspaceDetailMemberType } from '@/api/gen/_model/workspaceDetailMemberType';
import { useUser } from '@/lib/auth';
import { getInquiryLinkByCountryCode } from '@/module/plan/constants/inquiryLinks';
import { AlertBanner } from '@/shared/components';
import { Button } from '@/ui_v3';
interface PlanExpirationAlertBannerProps {
  alertType: 'D-7' | 'D-3' | 'D-day';
  onClose: () => void;
  workspaceMemberType: WorkspaceDetailMemberType;
  daysUntilExpiry: number;
}
type WorkspaceMemberType = Exclude<WorkspaceDetailMemberType, 'UNKNOWN'>;

/**
 * 플랜 만료 알림 배너 (AlertBanner 래퍼)
 * D-7, D-3, D-day 시점의 알림 메시지를 정의하고 AlertBanner로 렌더링합니다.
 * 사용자의 국가별로 다른 플랜 연장 문의 링크를 제공합니다.
 */
export const PlanExpirationAlertBanner = ({
  alertType,
  onClose,
  daysUntilExpiry,
  workspaceMemberType
}: PlanExpirationAlertBannerProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    user
  } = useUser();
  const ALERT_MESSAGES: Record<'D-7' | 'D-3' | 'D-day', Record<WorkspaceMemberType, string>> = {
    'D-7': {
      OWNER: t('common:alert.owner.expiredPlanLevel1', {
        n: daysUntilExpiry
      }),
      MEMBER: t('common:alert.member.expiredPlanLevel1', {
        n: daysUntilExpiry
      })
    },
    'D-3': {
      OWNER: t('common:alert.owner.expiredPlanLevel2', {
        n: daysUntilExpiry
      }),
      MEMBER: t('common:alert.member.expiredPlanLevel1', {
        n: daysUntilExpiry
      })
    },
    'D-day': {
      OWNER: t('common:alert.owner.expiredPlanLevel3'),
      MEMBER: t('common:alert.member.expiredPlanLevel3')
    }
  };
  return <AlertBanner type={alertType === 'D-day' ? 'error' : 'warning'} rightSlot={workspaceMemberType === 'OWNER' && <Button variant={'contained'} intent={'gradient'} size={'sm'} onClick={() => {
    window.open(getInquiryLinkByCountryCode(user?.countryCode));
  }}>
            {t('common:alert.inquiredExtendPlan')}
          </Button>} title={ALERT_MESSAGES[alertType][workspaceMemberType as WorkspaceMemberType]} onClose={onClose} datatype="plan-expiration-alert" data-sentry-element="AlertBanner" data-sentry-component="PlanExpirationAlertBanner" data-sentry-source-file="PlanExpirationAlertBanner.tsx" />;
};